<template>
    <div class="border-top">
        <div class="card-header">Choose a limit of locations:</div>
        <div class="card-body pt-0">
            <div class="d-flex align-items-center">
                <div class="d-flex my-1 align-items-center hand" v-for="tier in tiers" @click="selectTier(tier)"><i
                        class="radio-select mr-2" :class="{'radio-select-selected': isTierSelected(tier)}"></i><span
                        class="mr-2">{{ labelFor(tier) }}</span></div>
                <span class="ml-5" v-if="last_tier">For {{ last_tier.up_to }}+ Locations Call Us</span></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .hand {
        cursor: pointer;
    }
</style>

<script>
    export default {
        props: {
            value: {required: true},
            plan: {required: true}
        },
        data() {
            return {
                selected_tier: null,
                confirming_limit: null,
                form: new Form({
                    locations_limit: this.value || 1
                }),
                default_tiers: [
                    {up_to: 1, price_basic: 149, price_advanced: 199},
                    {up_to: 5, price_basic: 129, price_advanced: 169},
                    {up_to: 10, price_basic: 99, price_advanced: 129}
                ]
            };
        },

        watch: {
            value() {
                this.form.locations_limit = this.value || 1;
            }
        },

        computed: {
            tiered() {
                return this.plan.billing_scheme === 'tiered';
            },
            last_tier() {
                const tiersReversed = [].concat(this.tiers).reverse();
                return tiersReversed.length && tiersReversed[0];
            },
            tiers() {
                const tiers = this.tiered ? this.plan.tiers : this.default_tiers;
                return tiers.filter(t => t.up_to);
            }
        },

        created() {
            const tier = this.default_tiers.find(
                l => l.up_to === this.form.locations_limit
            );
            this.selectTier(tier);
        },

        methods: {
            isTierSelected(tier) {
                return this.form.locations_limit === tier.up_to;
            },

            selectTier(tier) {
                if (!tier) return;
                this.selected_tier = tier;
                this.form.locations_limit = tier.up_to;
                this.$emit('input', this.selected_tier.up_to);
            },

            labelFor(tier) {
                return tier.up_to > 1 ? `${tier.up_to} locations` : '1 location';
            },
        }
    };
</script>
